<template>
  <header class="block-header header" :class="{ 'header_scrolled': scrolledMobile }">
    <div class="header__container">
      <section class="header__main container_wide" v-if="!scrolledMobile">
        <div class="header__logo-wrapper">
          <img class="header__brand-logo" src="@/images/jeland_logo.png" alt="jeland" />
          <img class="header__brand-logo" src="@/images/jaecoo_logo.svg" alt="jaecoo" />
          <p><b>Автомир</b> <br/>Официальный дилер</p>
        </div>

        <div class="header__address-container">
          <img class="header__icon" src="../images/map-icon.svg" alt="" />
          <p>{{ CONSTANTS.address }}</p>
        </div>
        <p class="header__worktime">{{ CONSTANTS.worktimes[1] }}</p>
        <div class="header__phone-container">
          <img class="header__icon" src="../images/phone-icon.svg" alt="" />
          <a class="comagic_phone2" :href="`tel:${CONSTANTS.phone_raw}`">{{ CONSTANTS.phone }}</a>
        </div>
        <button class="header__call button button_blue" @click="getCall('sale')">Заказать звонок</button>
      </section>

      <nav class="header__nav" :class="{ 'header__nav_scrolled': is_scrolled > 74 && device_width > 750 }">
        <div class="header__nav-container container_wide">
          <div class="header__phone-call-wrapper">
            <div class="header__phone-container" :class="{ 'header__phone-container_scrolled': scrolledMobile }">
              <img src="../images/phone-icon.svg" alt="" />
              <a class="comagic_phone2" :href="`tel:${CONSTANTS.phone_raw}`">{{ CONSTANTS.phone }}</a>
            </div>
            <button class="header__call button button_blue" @click="getCall('sale')" v-if="!scrolledMobile">Заказать звонок</button>
          </div>
          <div class="header__links-wrapper">
            <ul class="header__links header__links-cars">
              <li
                class="header__link"
                v-for="(link, i) in carLinks"
                :key="`link-${i}`"
                @click="scrollTo(link.alias)"
              >
              <span v-if="link.new">Новый</span>
              <span v-html="link.label"></span>
              </li>
            </ul>
            <!-- <ul class="header__links header__links-blocks">
              <li
                class="header__link header__link_block"
                v-for="(link, i) in blockLinks"
                :key="`link-${i}`"
                @click="scrollTo(link.alias)"
              >
                {{ link.label }}
              </li>
            </ul> -->
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import Mask from "../common/mask";
import Mixin from "../common/mixin";
import Keyup from "../common/keyup";
import OuterClick from "../common/outer-click";
import CallbackForm from "./callback-form";
import Cars from '../common/cars-info';

import $ from "jquery";

export default {
  name: "blokc-header",
  components: { CallbackForm },
  directives: { Mask, Keyup, OuterClick },
  mixins: [Mixin],
  props: [""],
  data() {
    return {
      blockLinks: [
        //{ label: 'Подбор комплектации', alias: 'complects' },
        { label: 'Трейд-ин', alias: 'tradein' },
        { label: 'Кредит', alias: 'credit' },
        { label: 'Контакты', alias: 'contacts' },
      ],
      is_scrolled: 0,
      ny_worktime: false
    };
  },
  computed: {
    scrolledMobile() {
      return this.is_scrolled > 124 && this.device_width <= 750;
    },
    carLinks() {
      return Cars.map((car) => ({
        label: `${car.brand} ${car.name}`,
        alias: car.id,
        new: car.new
      }));
    },
    white_header() {
      return this.is_scrolled > 10;
    },
  },
  mounted() {
    $("html").on("keyup", (event) => {
      if (event.keyCode === 27) {
        this.show.creq = false;
      }
    });
    this.setOffset();
    window.addEventListener("scroll", this.setOffset);
  },
  methods: {
    scrollTo(where) {
      this.$emit("scrollTo", where);
    },
    setOffset() {
      if (typeof window.scrollY !== "undefined") {
        this.is_scrolled = window.scrollY;
      } else if (typeof window.pageYOffset !== "undefined") {
        this.is_scrolled = window.pageYOffset;
      }
    },
    toggleCreq() {
      if (this.device_platform === "phone") {
        this.getCall("sale");
        this.show.creq = false;
      } else {
        if (!this.show.creq) {
          this.blockScroll();
        } else {
          this.unblockScroll();
        }
        this.show.creq = !this.show.creq;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  font-size: 16px;
  background-color: #fff;
  position: relative;

  &__main,
  &__nav-container,
  &__address-container,
  &__phone-container {
    display: flex;
    align-items: center;
    text-transform: uppercase;
  }

  &__main,
  &__nav-container {
    justify-content: space-between;
  }

  &__nav-container {
    max-width: 1200px;
  }

  &__main {
    padding: 20px 20px;
    font-size: 12px;
  }

  &__logo-wrapper {
    display: flex;
    align-items: center;
    font-size: 0.9em;
  }

  &__dealer-logo {
    margin-right: 8px;
  }

  &__brand-logo {
    width: 140px;
    margin-right: 8px;
    padding-right: 8px;
    border-right: 1px solid #000;
  }

  &__nav {
    border-top: 1px solid #000;
    border-width: 1px 0 1px 0;
  }

  &__worktime {
    font-size: 14px;
  }

  &__nav &__phone-container img {
    margin-right: 5px;
  }

  &__phone-container {
    font-weight: 700;
    font-size: 16px;
  }

  &__call,
  &__link {
    text-transform: uppercase;
  }

  &__call {
    // font-weight: 700;
    // display: inline-block;
    // border-bottom: 1px solid #000;
    // cursor: pointer;
    width: fit-content;
    padding: 15px 40px;
  }

  &__links {
    padding: 16px 0;
    list-style-type: none;
    display: flex;
    width: max-content;
    font-size: 14px;

    &-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }

    &-cars {
      justify-content: center;
      gap: 15px;
    }

    &-blocks {
      gap: 45px;
    }
  }

  &__link {
    display: inline-block;
    cursor: pointer;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }

    &_block {
      font-weight: 400;
    }
  }

  &__phone-call-wrapper {
    display: none;
  }

  &__icon {
    margin-right: 10px;
  }

  /* Modifiers */

  &_scrolled,
  &__nav_scrolled {
    position: fixed;
    z-index: 10;
    top: 0;
    width: 100%;
    border-width: 0 0 1px 0;
    background-color: #fff;
  }
}

@media (max-width: 1320px) {
  .header {
    &__address-container,
    &__links:last-child {
      display: none;
    }

    &__nav-container {
      justify-content: center;
    }

    &__dealer-logo,
    &__brand-logo {
      width: 130px;
    }
  }
}

@media (max-width: 900px) {
  .header {
    &__worktime {
      display: none;
    }
  }
}

@media (max-width: 750px) {
  .header {
    &__main > &__phone-container,
    &__main > &__call,
    &__links {
      display: none;
    }
    
    &__links {
      &-wrapper {
        width: auto;
      }
    }

    &__nav-container {
      padding: 20px;
    }

    &__phone-call-wrapper {
      display: flex;
    }

    &__phone-call-wrapper > &__phone-container {
      margin-right: 40px;

      &_scrolled {
        margin: 0;
        font-size: 16px;
      }
    }

    &__call {
      padding: 10px 15px;
    }
  }
}

@media (max-width: 420px) {
  .header {
    &__phone-call-wrapper {
      width: 100%;
      justify-content: space-between;
      font-size: 12px;
    }

    &__phone-call-wrapper > &__phone-container {
      margin-right: 0;
    }

    &__phone-container {
      font-size: 12px;
    }

    &__main {
      font-size: 10px;
    }

    &__dealer-logo,
    &__brand-logo {
      width: 100px;
    }
  }
}
</style>
